import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';
import SenderView from './SenderView';
import SignatureView from './SignatureView';

const CommunicationsSetting: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useCommunicationsPage();

  const isTestButtonDisabled = !data.senderName || !data.senderEmailLocalPart;

  const isSaveButtonDisabled =
    !data.hasBeenModified ||
    isTestButtonDisabled ||
    (data.hasReplyTo && !data.isValidReplyToEmail) ||
    data.isReadOnly;

  return (
    <div className="card-inner overflow-y-auto">
      <SenderView />

      {data.hasSignatureView && <SignatureView />}

      <div className="row mt-4">
        <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
          <Button
            onClick={actions.handleSendTestEmail}
            disabled={isTestButtonDisabled}
            icon="ni ni-send"
            lgSize
          >
            {t('SendTestEmail')}
          </Button>
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
          <Button
            onClick={actions.handleSaveSettings}
            disabled={isSaveButtonDisabled}
            icon="ni ni-save"
            lgSize
          >
            {t('SaveChanges')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationsSetting;
